import { render, staticRenderFns } from "./ProductPrizeComponent.vue?vue&type=template&id=011873e4"
import script from "./ProductPrizeComponent.vue?vue&type=script&lang=js"
export * from "./ProductPrizeComponent.vue?vue&type=script&lang=js"
import style0 from "./ProductPrizeComponent.vue?vue&type=style&index=0&id=011873e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports